import React from 'react';
import { Component } from 'react';
import Card from '@mui/material/Card';
import { CardContent, CardHeader, Avatar } from '@mui/material';
import { Timeline } from 'react-twitter-widgets';
import Moment from 'react-moment';
import axios from 'axios';
import { BiLinkExternal } from 'react-icons/bi';
import { TypingText } from './AnimationTrigger';


const urls = [
    'https://script.google.com/macros/s/AKfycbzvVn71L5C-k9SaxAAYq_zg1waiP9TciuwTCYus0bLeFk54olHPnn-paX7mT32Eshl4/exec'
]

const HatenaCard = ({content}) => {
    const date = <Moment format="YYYY/MM/DD">{content.pubDate}</Moment>
    return (
        <Card>
            <CardHeader
                avatar={
                    <Avatar aria-label="Blog" sx={{ bgcolor: "#f44336"}}>
                        も
                    </Avatar>
                }
                subheader={date}
                title={content.title}
                style={{
                    color: "#515457"
                }}
            />
            <CardContent key={content.title}>
                <a className="external-btn" href={content.link} target="_blank" rel="noopener noreferrer">
                    <BiLinkExternal /> Read More
                </a>
            </CardContent>
        </Card >
    );
}

const HatenaTimeline = ({contents}) => {
    return (
        <div>
            <div className="subtitle">
                <h4>はてなブログ更新情報</h4>
            </div>
            <div className="scroll">
                {contents}
            </div>
        </div>
    );
}

const TwitterTimeline = () => {
    return (
        <Timeline
            dataSource={{
                sourceType: 'profile',
                screenName: 'Sashimimochi343'
            }}
            options={{
                username: 'Sashimimochi343',
                width: '100%',
                height: '400'
            }}
            onLoad={() => console.log('Timeline is loaded!')}
            />
    )
}

class SNS extends Component {
    constructor(props) {
        super(props);
        this.state = {
            contents: [],
        };
        this.componentDidMount = this.componentDidMount.bind(this)
    }
    componentDidMount() {
        urls.forEach((url) => {
            axios.get(url)
                .then((feed) => {
                    // 新たに取得したfeedを取り出す
                    const data = feed.data;
                    // 既存のstateを取り出しておく
                    var feeds = this.state.contents
                    // 既存のstateに新規で取得したfeedを1つずつ追加する
                    data.forEach((d) => {
                        feeds.push(d)
                    })
                    // 日付でsortする
                    feeds.sort(function (a, b) {
                        if (a.pubDate < b.pubDate) {
                            return 1;
                        }
                        if (a.pubDate > b.pubDate) {
                            return -1;
                        }
                        return 0
                    });
                    // stateをupdateする
                    this.setState({
                        contents: feeds
                    });
                })
                .catch((error) => {
                    console.error('Get Failed', error);
                })
        })
    }
    render() {
        const contents = this.state.contents.map(content => {
            return <HatenaCard content={content} key={content.title} />
        });

        return (
            <>
            <div className="title">
                <TypingText text="SNS" wrapper="h3" />
            </div>
            <div className="sns">
                <HatenaTimeline className="timeline" contents={contents} />
                <TwitterTimeline className="timeline" />
            </div >
            </>
        );
    }
}

export default SNS;